import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IAmenity, IAmenityType } from '@curbnturf/entities';
import {
  amenityFormBuilder,
  DisplayValidationErrorsDirective,
  IAmenityForm,
  ToggleComponent,
} from '@curbnturf/form-helpers';

@Component({
  selector: 'curbnturf-wheelchair-input',
  templateUrl: './wheelchair-input.component.html',
  styleUrls: ['./wheelchair-input.component.scss'],
  standalone: true,
  imports: [ToggleComponent, NgIf, FormsModule, ReactiveFormsModule, DisplayValidationErrorsDirective],
})
export class WheelchairInputComponent {
  @Input() amenities: FormArray<FormGroup<IAmenityForm>>;

  constructor(private fb: FormBuilder) {}

  selected(amenityType: IAmenityType['type']): boolean {
    if (!this.amenities) {
      return false;
    }

    const amenities = this.amenities.value.map((amenity) => amenity.type);

    return amenities.includes(amenityType);
  }

  toggleWheelchair() {
    if (this.selected('wheelchair')) {
      this.noWheelchair();
    } else {
      this.yesWheelchair();
    }
  }

  noWheelchair() {
    const amenities = this.amenities.value.map((amenity: IAmenity) => amenity.type);

    const index = amenities.indexOf('wheelchair');
    this.amenities.removeAt(index);
    this.amenities.markAsDirty();
  }

  yesWheelchair() {
    const wheelchairForm = amenityFormBuilder(this.fb, { type: 'wheelchair' });

    this.amenities.push(wheelchairForm);
    this.amenities.markAsDirty();
  }

  description() {
    const amenities = this.amenities.value.map((amenity: IAmenity) => amenity.type);

    const index = amenities.indexOf('wheelchair');
    if (index >= 0) {
      return this.amenities.controls[index].get('description');
    }

    return;
  }
}
